import React from "react";
import LoadingSpinner from "../Utils/Spinner";
import {Columns, Heading, Table} from "react-bulma-components";


export default function PartOrderFigures({partOrderData, partOrdersLoaded, totalProfit}){

    const colour = () => {
        if(totalProfit > 0){
            return "table-highlight-green-black-text"
        }
        else if(totalProfit < 0){
            return "table-highlight-red"
        }
        return "table-highlight-orange"
    }


    if(!partOrdersLoaded){
        return <LoadingSpinner/>
    }

    return (
        <div>
            <Heading>Part Orders</Heading>
            <Columns>
                <Columns.Column>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Total Part Order Cost</th>
                                <th>Total Part Order Customer Charge</th>
                                <th>Total Part Order Profit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{partOrderData.total_part_order_cost}</td>
                                <td>{partOrderData.total_part_order_customer_cost}</td>
                                <td className={colour()}>{totalProfit}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Columns.Column>
            </Columns>
        </div>
    )

}